export default "__VITE_ASSET__DpRCGFmD__"